import { getClientIdFromTracker } from '@otovo/shared/lib/analytics/gtm';
import UtmLocalStorage from '@otovo/shared/lib/analytics/queryParams/UtmLocalStorage';
import { extractUtmFromQuery } from '@otovo/shared/lib/analytics/queryParams/extractUtmFromQuery';

type UtmOverrides = {
  utmSource?: string;
  utmCampaign?: string;
  utmContent?: string;
  utmMedium?: string;
  utmTerm?: string;
  utmId?: string;
};

export function storeUtmData({
  utmSource,
  utmCampaign,
  utmContent,
  utmMedium,
  utmTerm,
  utmId,
  searchParams,
}: UtmOverrides & {
  searchParams: Record<string, string | string[]>;
}) {
  const existingUtmData = UtmLocalStorage.retrieve();

  // Extract UTM data from query params (supports shorthand codes)
  const queryUtmData = extractUtmFromQuery(searchParams);

  const gaClientId =
    (__isBrowser__ ? getClientIdFromTracker() : undefined) ||
    queryUtmData.ga_client_id ||
    existingUtmData.ga_client_id;

  // Check if we have overrides from Sanity
  const hasOverrides = !!(
    utmSource ||
    utmCampaign ||
    utmContent ||
    utmMedium ||
    utmTerm ||
    utmId
  );
  const hasQueryParams = Object.keys(queryUtmData).some(
    (key) => key.startsWith('utm_') && queryUtmData[key],
  );

  // If we have both query params and Sanity overrides, store query params as initial
  if (hasQueryParams && hasOverrides) {
    const initialData = {
      ...queryUtmData,
      ga_client_id: gaClientId,
      referrer: existingUtmData.referrer,
    };
    UtmLocalStorage.storeInitial(initialData);
  }

  // Build final UTM data with Sanity overrides taking precedence
  const finalUtmData = {
    utm_source:
      utmSource || queryUtmData.utm_source || existingUtmData.utm_source,
    utm_campaign:
      utmCampaign || queryUtmData.utm_campaign || existingUtmData.utm_campaign,
    utm_content:
      utmContent || queryUtmData.utm_content || existingUtmData.utm_content,
    utm_medium:
      utmMedium || queryUtmData.utm_medium || existingUtmData.utm_medium,
    utm_term: utmTerm || queryUtmData.utm_term || existingUtmData.utm_term,
    utm_id: utmId || queryUtmData.utm_id || existingUtmData.utm_id,
    gclid:
      queryUtmData.google_ads_click_id || existingUtmData.google_ads_click_id,
    gbraid: queryUtmData.google_ads_gbraid || existingUtmData.google_ads_gbraid,
    wbraid: queryUtmData.google_ads_wbraid || existingUtmData.google_ads_wbraid,
    ga_client_id: gaClientId,
    referrer: existingUtmData.referrer,
  };

  UtmLocalStorage.store(finalUtmData);
}
